import { useShippingSettings } from '@/hooks/useShippingSettings';
import { Truck, Check } from 'lucide-react';
import { Progress } from '@/components/ui/progress';

interface FreeShippingProgressProps {
  subtotal: number;
}

export function FreeShippingProgress({ subtotal }: FreeShippingProgressProps) {
  const { getProgressBarData, loading } = useShippingSettings();

  if (loading) return null;

  const progressData = getProgressBarData(subtotal);
  if (!progressData) return null;

  return (
    <div className="p-3 bg-muted/50 rounded-lg space-y-2">
      <div className="flex items-center gap-2 text-sm">
        {progressData.isFreeShipping ? (
          <>
            <Check className="h-4 w-4 text-green-500" />
            <span className="text-green-600 font-medium">{progressData.text}</span>
          </>
        ) : (
          <>
            <Truck className="h-4 w-4 text-muted-foreground" />
            <span className="text-muted-foreground">{progressData.text}</span>
          </>
        )}
      </div>
      <Progress value={progressData.progress} className="h-2" />
    </div>
  );
}